import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor(private spinner: NgxSpinnerService) {}

  show(): void {
    this.spinner.show();
    // console.log('LoadService Chamou');
  }

  hide(): void {
    this.spinner.hide();
    // console.log('Fechou Load');
    //this.refreshScroll();
  }

  // Ajuste temporario para o tooltip devido bug do mesmo aparece perdido quando iniciar, porem se chamar o scrol ele volta para o lugar correto.
  refreshScroll(): void {
    window.scrollTo(0, 10);
  }
}
